import React from 'react';
import {
  classNames,
  layoutClassNames,
  LayoutClassNameProps,
  surfaceClassNames,
  SurfaceShadow,
} from './classNames';
import { ButtonVariant } from './Button';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, LayoutClassNameProps {
  variant?: ButtonVariant;
  pill?: boolean;
  shadow?: SurfaceShadow;
  textBackground?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'secondary',
  pill = false,
  shadow,
  textBackground = false,
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <span
    className={classNames(
      'badge',
      `bg-${variant}`,
      textBackground ? `text-bg-${variant}` : undefined,
      pill ? 'rounded-pill' : undefined,
      surfaceClassNames({ shadow }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

export default Badge;
